module.exports = __webpack_public_path__ + "static/media/BovExo_template_vacinas.b5f0d739.xlsx";